export default {
    no_data: 'There\'s no data to show',
    loading: 'Loading records',
    search: 'Search',
}